import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilePreviewType } from 'library-explorer';
import { PreviewModalComponent } from '../components/preview-modal/preview-modal.component';
import { ViewerTypeExtensions } from '../document-viewer-extensions';
import { PreviewDialogConfig } from '../models/preview-dialog-config';


@Injectable({
  providedIn: 'root'
})
export class DocumentPreviewService {

  constructor(private readonly dialog: MatDialog) { }

  public openPreviewDialog(config: PreviewDialogConfig): void {
    const {
      file,
      presignedUrl = null,
      searchKey = '',
      entityId = null,
      isFileDownloadEnabled = true
    } = config;

    const fileName = file.filename;
    const fileExtension = fileName.split('.').reverse()[0].toLocaleLowerCase();
    const modes = Object.values(FilePreviewType);
    const mode = modes.find(key => ViewerTypeExtensions[key].indexOf(fileExtension) !== -1);

    this.dialog.open(PreviewModalComponent, {
      panelClass: ['preview-file-dialog', mode],
      data: {
        file,
        presignedUrl,
        mode,
        searchKey,
        entityId,
        isFileDownloadEnabled
      },
      autoFocus: false
    });
  }
}
